import { z } from 'zod';

import { LanguageEnum } from '../../enums';
import { languageEnumValidator } from '../../validators';

export const GetEtymologySchema = z.object({
  language: languageEnumValidator.optional().default(LanguageEnum.RU),
  word: z.string().min(1, 'Word cannot be empty'),
});

export type IGetEtymologyDto = z.infer<typeof GetEtymologySchema>;
